<template>
  <v-dialog v-model="show" width="700" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Edit</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="pagibig.pagibigCode"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="pagibig.pagibigDesc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employee Percentage"
              :class="classPadding"
              v-model="pagibig.empPer"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employer Percentage"
              :class="classPadding"
              v-model="pagibig.employerPer"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employee Amount"
              :class="classPadding"
              v-model="pagibig.empAmt"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="3" md="3" class="pb-0 mb-0">
            <v-text-field
              label="Employer Amount"
              :class="classPadding"
              v-model="pagibig.employerAmt"
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
        </v-row>-->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click.stop="show = false">Close</v-btn>
        <v-btn
          text
          color="success"
          @click.stop="save"
          :loading="isSaving"
          v-if="userAccess.update >= 1"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import isEmpty from "lodash/isEmpty";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/pagibig";
export default {
  mixins: [userAccessMixin],
  data: () => ({
    show: true,
    pagibig: {},
    isSaving: false,
    classPadding: "my-0 py-0"
  }),
  methods: {
    save() {
      this.isSaving = true;

      this.$axios
        .put(`${API_ENDPOINT}`, this.pagibig)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.$router.push("/pagibig-setup");
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  },
  computed: {
    ...mapState("pagibig", {
      selected: state => state.selected
    })
  },
  created() {
    this.pagibig = this.selected;

    this.getUserAccessRights("PagIbig");
  },
  watch: {
    show(val) {
      if (!val) {
        this.$router.push("/pagibig-setup");
      }
    },
    selected(val) {
      if (!isEmpty(val)) {
        this.pagibig = val;
      }
    }
  }
};
</script>